// If you change this, make sure to enable APIs on the new acct first!
// Needs Places API & Maps API
export const GOOGLE_API = 'AIzaSyDhNPOparncggfDvWDrQ59VV8Fjvs2xFZo'
